export default __webpack_public_path__ + "static/media/status-alert-icon.598ff293.svg";